import { RematchDispatch } from '@rematch/core';
import { axiosErrorHandler } from 'common/helpers';
import { IRootModel } from 'app/store';
import { physicianService } from 'entities/Physician/Physician.service';

export const physicianListEffects = (dispatch: RematchDispatch<IRootModel>) => ({
  async getPhysicianList() {
    dispatch.physicianList.setLoading(true);

    try {
      const response = await physicianService.getPhysicianList();
      dispatch.physicianList.setList(response);
      return response;
    } catch (error) {
      axiosErrorHandler(error);
      return null;
    } finally {
      dispatch.physicianList.setLoading(false);
    }
  },
});
